import dollarFormat from './dollar-format';

export default {
  install(app) {
    // Register directives globally
    app.directive('dollar-format', dollarFormat);
  }
}; 